<template>
  <fo-layout>
    <a-spin :spinning="loading">
      <a-row :gutter="30" v-if="data.length">
        <a-col :sm="8" v-for="(item, ind) in data" :key="ind">
          <div class="pb-30">
            <card
              class="card-shadow"
              :imgurla="item.business_icon_active"
              :imgurlb="item.business_icon_default"
              :title="item.business_title_zh"
              :info="item.business_content"
              @click="$router.push('./areas/' + item.code)">
            </card>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="30" v-else>
        <a-col :sm="8" v-for="(item, ind) in 3" :key="ind">
          <div class="pb-30">
            <card class="card-shadow"></card>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </fo-layout>
</template>

<script>
import card from './comps/cardAreas.vue'
export default {
  components: {
    card
  },
  data () {
    return {
      loading: false,
      data: [],
      cond: {
        page_num: '1',
        page_size: '6'
      }
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readList()
  },
  methods: {
    readList () {
      this.loading = true
      this.get({
        url: 'businessRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.data = res.data.items
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Models/areas.vue